<template>
    <div 
    :style="{ backgroundImage: 'url(' + background + ')'}"
    class="container-fluid pt-4">

        <b-container>
            <HMenu v-if="!(user.role === '230' || user.role === '039' || user.role === '056'  || user.role === '016'  || user.role === '11705' || user.role === '11716' ||  user.role === '059' || user.role === '1001' || user.role === '1002')||$route.matched.some(({ name }) => name === 'calculadora')" />
          
            <div v-if="!(user.role === '230' || user.role === '039' || user.role === '056' ||user.role === '016'  || user.role === '11705' || user.role === '11716' ||  user.role === '059' || user.role === '1001' || user.role === '1002')">
                <div  v-if="encuesta() =='no'" class="div-encuesta">
                FANOSA  necesita tu opinión, te agradeceríamos que nos dieras un poco de tu tiempo para responder una breve encuesta. &#10142; <a :href="getBuzonPath(this.user)">ir a la encuesta</a>  
                 </div>
            </div>
           
            <div class="row" v-if="!$route.matched.some(({ name }) => name === 'calculadora')">
                <div id='headerColab' class="col-9 col-sm-9 col-md-8 text-white pt-3 pb-4 pl-4 ">
                    <p class="stylingH1"> ¡Hola, {{name | split }}! </p>
                    <p class= "stylingH2"> Este es tu resumen semanal </p>
                    <p class="text-white stylingName">{{week}}</p>
                </div>
                <div v-if="!(user.role === '230' || user.role === '039' || user.role === '056' ||user.role === '016'  || user.role === '11705' || user.role === '11716' ||  user.role === '059' || user.role === '1001' || user.role === '1002')" class="pt-4 col-3 col-sm-3 col-md-4">
                    <img :src="dataUrl" class="user">
                </div>
            </div>
            <ProgressBar v-if="!(progressCities.includes(city) && depto === 'Insulpanel' || 
            progressCities.includes(city) && depto === 'Bono Garantía' || 
            progressCities.includes(city) && depto === 'Vigueta' ||
            depto === 'Mantenimiento'||$route.matched.some(({ name }) => name === 'calculadora'))"
            :goal="goal"
            :progress="progress"
            />
             
            <b-row>                 
                <b-col class="bg-gris py-3" style="margin-bottom: 6em;" v-if="!$route.matched.some(({ name }) => name === 'calculadora')"> 
                    <h4 class="px-3 pt-2 stylingNameColab">{{name | cap }}</h4>
                    <h4 class="px-3 pb-2 stylingDepto">Departamento: <strong>{{depto}}</strong></h4>
                   
                    <b-row class="px-4 py-2" v-if="!(progressCities.includes(city) && depto === 'Insulpanel' || progressCities.includes(city) && depto === 'Bono Garantía' || progressCities.includes(city) && depto === 'Vigueta' || depto === 'Mantenimiento')">                        
                        <b-col class="bg-white pila mr-2">   
                            <b-row >
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #ff4a4a;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall"> Meta<br>semanal </p>
                                    <h4 v-if="goal" class="stylingH4G">{{goal}}</h4>
                                    <h4 v-else class="stylingH4G">0</h4>
                                </b-col>
                            </b-row>                                                     
                        </b-col>
                        
                        <b-col class="bg-white pila ml-1">
                            <b-row>
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #00c290;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Producción<br>al día </p>
                                    <h4 class="stylingH4G">{{m3 | rand }}</h4>
                                </b-col>
                            </b-row>                       
                        </b-col>
                    </b-row>

                    <b-row class="px-4 py-2">
                        <b-col class="bg-white pila mr-2">
                            <b-row>
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #9d3eff;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Días<br>Laborados </p>
                            <h4 class="stylingH4G">{{days}}</h4>
                                </b-col>
                            </b-row>  
                        </b-col>
                        <b-col class="bg-white pila ml-1">
                            <b-row>
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #6791fb;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Mis<br>asistencias </p>
                                    <h4 class="stylingH4G">{{asis}}</h4>
                                </b-col>
                            </b-row>  
                            
                        </b-col>
                    </b-row>

                    <b-row class="px-4 py-2" v-if="!(depto === 'Bono Garantía')">
                        <b-col class="bg-white pila mr-2">
                            <b-row v-if="(city === 'Hermosillo' || city === 'Mexicali') && depto === 'Insulpanel'">
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #fbda67;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Nivel de carrera</p>
                                    <h4 class="stylingH4G">$ {{carrera}}</h4>
                                </b-col>
                            </b-row>
                            <b-row v-else-if="insupanelCity.includes(city)  && depto === 'Insulpanel'">
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #fbda67;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Bono por<br>productividad</p>
                                    <h4 class="stylingH4G">$ {{bonus_prod | rand}}</h4>
                                </b-col>
                            </b-row>
                            <b-row v-else-if="city === 'La Paz' && depto === 'Vigueta'">
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #fbda67;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Pago base</p>
                                    <h4 class="stylingH4G">$ {{bonus_tot | rand }}</h4>
                                </b-col>
                            </b-row>
                            <b-row v-else-if="depto === 'Mantenimiento'">
                                 <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #78d9ee;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Promedio areas</p>
                                    <h4 class="stylingH4G">$ {{promedio }}</h4>
                                </b-col>
                               
                            </b-row>
                            <b-row v-else>
                                 <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #fbda67;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Precio por<br>excedente</p>
                                    <h4 class="stylingH4G">$ {{extra | rand }}</h4>
                                </b-col>                               
                            </b-row>                                
                        </b-col>
                        <b-col class="bg-white pila ml-1">
                            <b-row v-if="(insupanelCity.includes(city) && depto === 'Insulpanel' || city === 'La Paz' && depto === 'Vigueta')">
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #78d9ee;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Premio o castigo por metas</p>
                                    <h4 class="stylingH4G">$ {{bonus_goals }} </h4>
                                </b-col>
                            </b-row>
                            <b-row v-else-if="depto === 'Mantenimiento'">
                               <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #fbda67;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Premio o castigo<br>por energéticos</p>
                                    <h4 class="stylingH4G">$ {{energeticos }}</h4>
                                </b-col>
                            </b-row>
                            <b-row v-else>
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #78d9ee;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Bono por<br>productividad</p>
                                    <h4 class="stylingH4G">$ {{bonus_prod | rand}}</h4>
                                </b-col>
                            </b-row>  
                            
                            
                        </b-col>
                    </b-row>

                    <b-row class="px-4 py-2">
                        <b-col class="bg-white pila mr-2">
                            <b-row v-if="insupanelCity.includes(city) && depto === 'Insulpanel'">
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #ff4a4a;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Bono semanal del departamento </p>
                                    <h4 class="stylingH4G">$ {{bonus_tot | rand }}</h4>
                                </b-col>
                            </b-row> 
                            <b-row v-else-if="depto === 'Bono Garantía'">
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #ff4a4a;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Pago base</p>
                                    <h4 class="stylingH4G">$ {{base}}</h4>
                                </b-col>
                            </b-row> 
                            <b-row v-else-if="city === 'La Paz' && depto === 'Vigueta'">
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #ff4a4a;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Bono diario del departamento </p>
                                    <h4 class="stylingH4G">$ {{bonus_tot | rand }}</h4>
                                </b-col>
                            </b-row> 
                            <b-row v-else-if="depto === 'Mantenimiento'">
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #ff4a4a;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Descuentos<br> faltas/retardos </p>
                                    <h4 class="stylingH4G">$ {{descuento }}</h4>
                                </b-col>
                            </b-row> 
                            <b-row v-else>
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #ff4a4a;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Premio o castigo por metas</p>
                                    <h4 class="stylingH4G">$ {{bonus_goals}} </h4>
                                </b-col>
                            </b-row>                              
                        </b-col>

                        <b-col v-if="depto != 'Mantenimiento'" class="bg-white pila mr-2" >    
                            <b-row >
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #ff4a4a;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Descuentos<br> faltas/retardos </p>
                                    <h4 class="stylingH4G">$ {{descuento }}</h4>
                                </b-col>
                            </b-row> 
                              
                        </b-col>

                        <b-col v-if="depto === 'Mantenimiento'" class="bg-white pila mr-2" >    
                           <b-row>
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #00c290;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Bono semanal del departamento </p>
                                    <h4 class="stylingH4G">$ {{bonus_tot | rand }}</h4>
                                </b-col>
                            </b-row>   
                              
                        </b-col>
                              

                    </b-row>

                     <b-row v-if="depto != 'Mantenimiento'" class="px-4 py-2">
                      

                        <b-col class=""
                        :class="['pila ml-1', { 'pila0' : (insupanelCity.includes(city) && depto === 'Insulpanel' || city === 'La Paz' && depto === 'Vigueta'), 
                        'bg-white' : !(insupanelCity.includes(city) && depto === 'Insulpanel' || city === 'La Paz' && depto === 'Vigueta')}]"
                        >    
                            
                            <b-row v-if="(insupanelCity.includes(city) && depto === 'Insulpanel' || city === 'La Paz' && depto === 'Vigueta')">
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #ff9d3e;"></div></b-col>
                                <b-col class="pl-3 ">
                                    <p class="stylingSmallO">Bono total* </p>
                                    <h4 class="stylingH4O">$ {{bonus_p | rand }}</h4>
                                </b-col>
                            </b-row>  

                            <b-row v-else >
                                <b-col cols="1" class="pr-0 pt-1"><div class="square" style="background-color: #00c290;"></div></b-col>
                                <b-col class="pl-3">
                                    <p class="stylingSmall">Bono semanal del departamento </p>
                                    <h4 class="stylingH4G">$ {{bonus_tot | rand }}</h4>
                                </b-col>
                            </b-row>        
                        </b-col>

                    </b-row>

                    <b-row class="px-4 py-2" v-if="!(insupanelCity.includes(city) && depto === 'Insulpanel' || city === 'La Paz' && depto === 'Vigueta')" >
                        <b-col class="pilaO">
                            <div class="row">
                                <div class="col-4 col-sm-4 pl-4 pt-1">
                                    <p class="stylingSmallO" style="margin-left: .5rem;">Bono total* </p>
                                </div>
                                <div class="col-8 col-sm-8 pl-4 pt-0" >
                                   <h4 class="stylingH4O float-right" style="margin-right: .5rem;">$ {{bonus_p | rand }}</h4>
                                </div>
                            </div> 
                        </b-col>
                    </b-row>
                    <b-row class="px-4 py-2 float-right">
                        <p class="stylingSmall2 pr-1">*Bono total sujeto a cambio de condicionantes</p>
                    </b-row>          
                    
                </b-col>
            </b-row>
            <b-row>
                 <!-- v-if="!(user.role === '230' || user.role === '039' || user.role === '056')" -->
                <Footer v-if="!(user.role === '230' || user.role === '039' || user.role === '056' || user.role === '016' || user.role === '11705' || user.role === '11716' || user.role === '059' || user.role === '1001' || user.role === '1002')"
                :user="user"/> 
            </b-row>

                
                
               

        </b-container> 
        
    </div>
</template>

<script>
import img from '../assets/fondoazul.png';
import profile from '../assets/user.png';
import ProgressBar from './ProgressBar';
import Footer from './Footer'
import HMenu from './HeaderIcons';
import userService from '../services/user.service';
import 'video.js/dist/video-js.css' 
import { videoPlayer } from 'vue-video-player'
 


export default {
    name: 'DeptoBase',
    props: {
        goal:{
            required: true,
        },
        progress: {
            required: true,
        },
        name: {
            required: true,
        },
        depto: {
            required: true,
        },
        city:{
            required: false,
        },
        days: {
            required: true,
        },
        m3: {
            required: true,
        },
        bonus_p: {
            required: true,
        }
        ,
        bonus_tot: {
            required: true,
        },
        asis: {
            required: true,
        },
        extra: {
            required: true,
        },
        bonus_prod: {
            required: false
        },
        bonus_goals: {
            required: false
        },
        carrera:{required: false},
        base:{required: false},
        energeticos:{required: false},
        fugas:{required: false},
        descuento:{required: false},
        promedio:{required: false},
    },
    components: {ProgressBar, Footer, HMenu},
    data() {
        return {
            background: img,
            userimg: profile,  
            insupanelCity: ['Guadalajara', 'Querétaro'],
            progressCities: [
                'Cancun',
                'CDMX',
                'Culiacan',
                'Guadalajara',
                'Hermosillo',
                'Mexicali',
                'Juarez',
                'La Paz',
                'Merida',
                'Monterrey',
                'Nogales',
                'Queretaro',
                'Tijuana',
                'Veracruz',
                'Villahermosa'
            ],                 
        }
    },
    created() {
        this.$store.dispatch("admin/week");
    },
    async beforeMount() {
        let token = await this.$store.dispatch("userService/getToken");
        this.$store.dispatch("userService/decode", token);
    },     
    computed:{
        week() {
            return this.$store.getters["admin/getWeek"];
        },
        user() {            
            return this.$store.getters['userService/getIdentity'];
        },
        dataUrl(){
            let token = userService.getToken();
            let identity = userService.decode(token);
            return 'data:img/jpeg;base64,' + btoa(
                new Uint8Array(identity.img.data)
                .reduce((data, byte) => data + String.fromCharCode(byte), '')
            );}
    },
    methods:{
        encuesta: function(){
            return localStorage.getItem('survey')
        },
        Buzon: function () {
            alert('hola')
             let path = getBuzonPath(this.user);

             this.$router.push(path).catch((err) => {});
             
        },
         getBuzonPath: function(user){
            //console.log(user)
            let normalized = this.normalize(user.city, user.depto);            
            let code = user.num;
            return '/'+normalized.city+'/'+normalized.depto+'/'+code+'/'+ 'buzon';
        },
        normalize: function(cities, deptos){
            let city = cities.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
            let depto = deptos.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\ ]/g, "");
            return {city, depto};
        },
    },
    filters:{
        split: (value) => {
            if (!value) return '';
            value = value.toString();

            let splitStr = value.toLowerCase().split(' ');
            let len = splitStr.length
            let i;
            
            for ( i = 0; i < len; i++) {
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
            }
            let nameCap = splitStr.join(' '); 
            let newName = nameCap.split(' ').slice(0, -1).join(' ')

            return newName;
        },
        rand: (value) => {
            if (!value || value < 0) return '0';
            if (typeof value === 'number') {
                return value.toFixed(2);
            }
            return value;
        },
        cap: (value)=>{
            if (!value) return '';
            value = value.toString();
            
            let splitStr = value.toLowerCase().split(' ');
            let len = splitStr.length
            let i; 
            for ( i = 0; i < len; i++) {
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
            }
            let nameCap = splitStr.join(' '); 
            return nameCap;
        }
    },
}
</script>
